import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { PageContainer } from '../../../components/layout/page/PageContainer';
import { PageContainerTitle } from '../../../components/layout/page/PageContainerTitle';
import CourseList from '../../../components/course/CourseList';
import FindCourseBanner from '../../../components/course/FindCourseBanner';
import {
  COURSE_CATEGORIES,
  SUB_TYPE_BY_SLUG,
} from '../../../constants/course-categories';

/** 서브타입(카테고리)별 코스 페이지 */
const CourseCategory = () => {
  const { productSubType } = useParams();
  const subType = SUB_TYPE_BY_SLUG[productSubType ?? ''];
  const course = COURSE_CATEGORIES.find(
    (item) => item.productSubType === subType,
  );

  if (!subType) {
    return <Navigate to="/courses" replace />;
  }

  return (
    <PageContainer>
      <PageContainerTitle
        variant="accent"
        title={course?.pageTitle ?? '젭스 코스'}
        description={course?.pageDescription ?? '지금 바로 시작할 수 있는 코스'}
      />

      <section className="pt-[25px] xl:pt-[48px]">
        <CourseList productSubType={subType} />
      </section>

      <FindCourseBanner />
    </PageContainer>
  );
};

export default CourseCategory;
